import React from 'react'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Switch from '@material-ui/core/Switch'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import ClearIcon from '@material-ui/icons/Clear'
import DoneIcon from '@material-ui/icons/Done'
import PropTypes from 'prop-types'
import './EditDisclaimeText.scss'
import { withStyles } from '@material-ui/core/styles'

const styles = {
  buttonRoot: {
    border: 'none',
    '&:hover': {
      backgroundColor: 'transparent'
    }
  }
}

function EditDisclaimeText(props) {
  const { classes, disclaimerText, showDisclaimer, defaultDisclaimerText } = props

  return (
    <>
      <div className="edit-disclaimer-container">
        <div className="input-textbox-buttons">
          <form
            name="form_edit"
            className="action_formblock"
            onSubmit={props.updateDisclaimerText}
          >
            <TextField
              autoFocus
              margin="dense"
              name="disclaimerText"
              defaultValue={disclaimerText || defaultDisclaimerText}
              type="text"
              fullWidth
              inputProps={{ 'data-testid': 'disc_texttoupdate' }}
            />
            <div className="cancel-done-button-group">
              <ClearIcon
                data-testid="disc_actions_clear"
                id="action-clear"
                onClick={props.cancelDisclaimerText}
              />
              <Button
                data-testid="disc_actions_submit"
                type="submit"
                color="primary"
                className={classes.buttonRoot}
              >
                <DoneIcon />
              </Button>
            </div>
          </form>
        </div>
        <div>
          <FormControlLabel
            control={
              <Switch
                checked={showDisclaimer}
                onChange={props.handleShowDisclaimer}
                name="showDisclaimer"
                color="primary"
                inputProps={{ 'data-testid': 'showDisclaimer_switch' }}
              />
            }
            label="Show"
            labelPlacement="start"
          />
        </div>
      </div>
    </>
  )
}

EditDisclaimeText.propTypes = {
  disclaimerText: PropTypes.string,
  updateDisclaimerText: PropTypes.func,
  cancelDisclaimerText: PropTypes.func,
  showDisclaimer: PropTypes.bool,
  handleShowDisclaimer: PropTypes.func,
  classes: PropTypes.object,
  defaultDisclaimerText: PropTypes.string
}

export default withStyles(styles)(EditDisclaimeText)
